import { ContactSupportOutlined } from "@mui/icons-material";

const initialState = {
  expertAnalyticsData: [],
  ratings: {},
  ratingStars: [],
  getExpertQCounts: [],
  getCurationCount: [],
  getAuditLogs: [] /* Seeker Overview Graph API*/,
  actionValue: { label: "Trending Search", value: 59,id:null },
  totalCount: 0,
  duration: { label: "Last Month", value: null },
  source: { label: "All Source", value: "0,1,2,3,4,5,6,7,8,9,10" },
  questionCountData: [],
  getDomainsByTimeline: [],
  getQuestionsCount: [],
  getDomainListCount: [] /* Seeker Overview Graph API*/,
  questionCountBreakdown: [] /* Seeker Overview Graph API*/,
  durationQ: { label: "Last Month", value: null },
  answeredByVizertoDuration: { label: "Last Month", value: null },
  trendingSearchDuration: { label: "Last Month", value: null },
  domainSpecificData: [],
  domainSpecificDuration: { label: 'Last Month', value: null },
  avgAccuracyCount: 0,
  expertAnalyticsQuestions: [],
  actionName:""
};

const expertOverviewCmReducer = (state = initialState, action) => {
  switch (action.type) {
    case "getviewsforoverviewexpert":
      // state = { ...state, expertAnalyticsData: action.payload};
      // const analyticsData = action.payload.length;
      // // const sortedArr = state.expertAnalyticsData.sort((a, b) =>  b.views - a.views)
      // if (analyticsData > 20) {
      //   const newArr = action.payload.slice(0, 20)
      //   newArr = newArr.sort((a,b)=>b.views - a.views)
      //   state = { ...state, expertAnalyticsData: newArr }
      //   return state;
      // }
      // else {
      //   let sortedArr = action.payload.sort((a,b)=>b.views-a.views)
      //   console.log(sortedArr,'check sorted attay')
      //   state = { ...state, expertAnalyticsData: sortedArr }
      //   return state;
      // }
      let expertAnalyticsDataCopy = [...action.payload];

      if (expertAnalyticsDataCopy.length > 20) {
          // Slice the array to get only the first 20 elements and sort them
          let newArr = expertAnalyticsDataCopy.slice(0, 20);
          newArr.sort((a, b) => b.views - a.views);         
          // Return the updated state with the sorted array
          return {
              ...state,
              expertAnalyticsData: newArr,
          };
      } else {
          // Sort the array
          expertAnalyticsDataCopy.sort((a, b) => b.views - a.views);       
          // Return the updated state with the sorted array
          return {
              ...state,
              expertAnalyticsData: expertAnalyticsDataCopy,
          };
      }

    case "getratingsbydatainexpertoverview":
      state = { ...state, ratings: action.payload };
      const RatedData = [];
      const getAllValues = Object.values(action.payload);
      const sum = getAllValues.reduce((a, b) => {
        return a + b;
      }, 0);
      const nonRated = Object.entries(action.payload).map(([name, value]) => ({
        name,
        value,
      }));
      const obj1 = { name: "Rated", value: sum };
      const obj2 = {
        name: "Non-Rated",
        value: nonRated.length >= 0 && nonRated[0].value,
      };
      RatedData.push(obj1);
      RatedData.push(obj2);
      state = { ...state, ratings: RatedData };
      return state;
    case "getratingstarsdataforexpertoverview":
      state = { ...state, ratingStars: action.payload };
      const totalVal = Object.values(state.ratingStars).reduce((a, b) => a + b, 0)
      const ratingStarsData = Object.entries(state.ratingStars).map(
        ([name, value]) => ({ name: name + " " + "star", value: Math.round(value / totalVal * 100), total: totalVal, ratings: value })
      );
      // ratingStarsData.splice(0, 1);
      ratingStarsData.shift()
      let filteredArray = ratingStarsData.filter((obj) => {
        if (obj.value > 0) {
          return obj;
        }
      })
      state = { ...state, ratingStars: filteredArray };
      return state;
    case "getexpertsqcountsdata":
      state = { ...state, getExpertQCounts: action.payload };
      let arr1 = state.getExpertQCounts[0];
      let arr2 = state.getExpertQCounts[1];
      let arr4 = state.getExpertQCounts[2];
      let arr5 = state.getExpertQCounts[3];
      let arr6 = state.getExpertQCounts[4];
      let arr7 = state.getExpertQCounts[5];
      let arr8 = state.getExpertQCounts[6];
      if (arr1.length > 30) {
        // arr1 = arr1.slice(0, 30)
        const mergeAll = (arr1, arr2, arr4, arr5, arr6, arr7, arr8) => {
          let newArr = [];
          arr1.filter((obj, ind) => {
            let newObj = {
              name: obj,
              "1 Star": parseInt(arr2[ind]),
              "2 Star": parseInt(arr4[ind]),
              "3 Star": parseInt(arr5[ind]),
              "4 Star": parseInt(arr6[ind]),
              "5 Star": parseInt(arr7[ind]),
              "Not Rated": parseInt(arr8[ind]),
              "Total Ratings": parseInt(arr2[ind]) + parseInt(arr4[ind]) + parseInt(arr5[ind]) + parseInt(arr6[ind]) + parseInt(arr7[ind])
            };
            newArr.push(newObj);
          });
          return newArr.sort((a, b) => { return b['Total Ratings'] - a['Total Ratings'] }).slice(0,30);
        };
        state = {
          ...state,
          getExpertQCounts: mergeAll(arr1, arr2, arr4, arr5, arr6, arr7, arr8),
        };
        return state;
      }
      else {
        const mergeAll = (arr1, arr2, arr4, arr5, arr6, arr7, arr8) => {
          let newArr = [];
          arr1.filter((obj, ind) => {
            let newObj = {
              name: obj,
              "1 Star": parseInt(arr2[ind]),
              "2 Star": parseInt(arr4[ind]),
              "3 Star": parseInt(arr5[ind]),
              "4 Star": parseInt(arr6[ind]),
              "5 Star": parseInt(arr7[ind]),
              "Not Rated": parseInt(arr8[ind]),
              "Total Ratings": parseInt(arr2[ind]) + parseInt(arr4[ind]) + parseInt(arr5[ind]) + parseInt(arr6[ind]) + parseInt(arr7[ind])
            };
            newArr.push(newObj);
          });
          return newArr.sort((a, b) => { return b['Total Ratings'] - a['Total Ratings'] });
        };
        state = {
          ...state,
          getExpertQCounts: mergeAll(arr1, arr2, arr4, arr5, arr6, arr7, arr8),
        };
        return state;
      }
    // return state;
    case "getcurationcountcmexpert":
      state = { ...state, getCurationCount: action.payload };
      var arr = Object?.entries(state.getCurationCount).map(([name, obj]) => ({
        name,
        ...obj,
        totalCount: Object.values(obj).reduce((a, b) => a + b, 0)
      }));
      var arr = arr.sort((a, b) => { return b.totalCount - a.totalCount })
      if (arr.length > 20) {
        arr = arr.slice(0, 20)
        // arr = arr.sort((a,b)=>{return b.totalCount - a.totalCount})
        state = { ...state, getCurationCount: arr }
        return state;
      }
      // console.log(arr,'check array')
      state = { ...state, getCurationCount: arr };
      return state;
    case "getauditlogsdata":
      state = { ...state, getAuditLogs: action.payload };
      return state;
    case "getactionvalueandlabel":
      state = { ...state, actionValue: action.payload };
      return state;
    case "getdurationinmonths":
      state = { ...state, duration: action.payload };
      return state;
    case "gettotalcount":
      state = { ...state, totalCount: action.payload };
      return state;
    case "getsourcevalue":
      state = { ...state, source: action.payload };
      return state;
    case "getquestioncountdata":
      state = { ...state, questionCountData: action.payload };
      return state;
    case "getdomainstimelinedata":
      state = { ...state, getDomainsByTimeline: action.payload };
      return state;
    case "getquestionscountbyday":
      state = { ...state, getQuestionsCount: action.payload };
      return state;
      case "getActionName":
        state = { ...state, actionName: action.payload };
        return state;
      // getActionName
    case "getdomainslistcount":
      state = { ...state, getDomainListCount: action.payload };
      return state;
    case "getquestioncountbreakdown":
      state = { ...state, questionCountBreakdown: action.payload };
      let newArrayQuestionCount = state.questionCountBreakdown[1];
      let newArrayQuestionCount1 = state.questionCountBreakdown[2];
      let newArrayQuestionCount2 = state.questionCountBreakdown[3];
      let totalQuestionsCount = [];
      state.questionCountBreakdown[0].map((obj, ind) => {
        let qCount = {
          name: obj,
          Open: Number(newArrayQuestionCount[ind]),
          Answered: Number(newArrayQuestionCount1[ind]),
          Accepted: Number(newArrayQuestionCount2[ind]),
        };
        totalQuestionsCount.push(qCount);
      });
      state = { ...state, questionCountBreakdown: totalQuestionsCount };
      return state;
    case "getmonthsvalueforquestionssubmitted":
      state = { ...state, durationQ: action.payload };
      return state;
    case "getmonthsdurationforansweredbyvizerto":
      state = { ...state, answeredByVizertoDuration: action.payload };
      return state;
    case "gettrendingsearchdurationmonths":
      state = { ...state, trendingSearchDuration: action.payload };
      return state;
    case "getdomainspecifictimelinedata":
      state = { ...state, domainSpecificData: action.payload };
      return state;
    case "getdomainspecifictimeduration":
      state = { ...state, domainSpecificDuration: action.payload }
      return state;
    case "averageaccuracycount":
      state = { ...state, avgAccuracyCount: action.payload }
      return state;
    case "getexpertanalyticsforcmoverviewquestions":
      state = { ...state, expertAnalyticsQuestions: action.payload }
      if(action.payload.length > 20)
      {
      let newArrSort = action.payload.slice(0,20)
      let newArrQ = newArrSort.sort((a, b) => { return b.answers - a.answers })
      state = { ...state, expertAnalyticsQuestions: newArrQ }
      return state;
      }
      else 
      {
        let newArrQ = action.payload.sort((a,b)=>{return b.answers - a.answers})
        state = {...state,expertAnalyticsQuestions:newArrQ}
        return state;
      }
    default:
      return state;
  }
};
export default expertOverviewCmReducer;
